import clsx from 'clsx';
import { LoaderCircle } from 'lucide-react';

const sizes = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-16 w-16',
    xl: 'h-24 w-24',
};

const variants = {
    light: 'text-white',
    primary: 'text-600',
};

export type SpinnerProps = {
    size?: keyof typeof sizes;
    variant?: keyof typeof variants;
    className?: string;
};

export const SharedSpinner = ({ size = 'sm', variant = 'primary', className = '' }: SpinnerProps) => {
    return (
        <>
            <LoaderCircle className={clsx('animate-spin', sizes[size], variants[variant], className)} />
            <span className="sr-only">Loading</span>
        </>
    );
};
